import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- // 
import { LocalSEO } from 'components/blocks/portfolio'; 
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO'; 
import * as All from 'data/keywords';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Miguel Madeira Music',
  categories: 'wordpress, web services',
  description:
    'Miguel Madeira Music is a music composer, arranger and producer. We were asked to design and develop a new website for him. We also provided SEO services.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[8].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        {/* ========== SEO META values ========== */}

        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
urlENPT={``}
url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />

        {/* ========== heading section ========== */}
        <section
          className="wrapper image-wrapper bg-image bg-overlay text-white"
          style={{
            backgroundImage: 'url(/img/clients/' + Portfolio[1].title.toLowerCase().replace(/ /g, '-') + '-bg.jpg)',
            backgroundSize: 'cover'
          }}
        >
          <div className="container pt-17 pb-12 pt-md-19 pb-md-16 text-center">
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="post-header">
                  {/* <div className="post-category text-line text-white">
                    <NextLink title="Identity" href="#" className="text-reset" />
                  </div> */}
                  <h1 className="fs-15 text-uppercase text-white mb-3">{Portfolio[0].title}</h1>
                  <p className="display-4 text-capitalize mx-auto">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className="display-6 mb-4">{details.pageName}</h2>

                <div className="row">
                  <div className="col-md-8 text-justify">
                    <p>
                      {/* <NextLinkNoAlt href={keywords[0].url} title={keywords[0].title} /> */}
                      {/* <br /> */}
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <p>
                      Miguel Madeira is a talented musician with a passion for delivering quality music services to
                      media agencies and film companies. He approached SEOptimist {' '}
                      <NextLink title={All.HomeList[2].title} href="/" /> with a goal of creating a website that
                      reflected his unique style and brand. At SEOptimist web design West Sussex, we were happy to assist
                      him in achieving his goal by providing a custom WordPress web design.
                    </p>
                    <h2>{Portfolio[1].title}</h2>
                    <p>
                      Our team of skilled web designers and developers worked closely with Miguel to understand his
                      vision and goals for the website. We started by creating a custom WordPress theme that reflected
                      his unique style and brand. SEOptimist used the latest web design tools and techniques to ensure
                      that the website was responsive, easy to navigate, and visually appealing.
                    </p>
                    <h2>{Portfolio[2].title}</h2>
                    <p>
                      We also customized the WordPress theme to include features that were important to Miguel, such as
                      an audio player that allowed his fans to stream his music directly from the website. We also
                      integrated social media widgets that made it easy for visitors to share his content on various
                      social media platforms.
                    </p>{' '}
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[2].title}
                      style={{ background: 'transparent' }}
                      className="mb-5 mw"
                    />
                    <p>
                      Our team also provided Miguel with training on how to use the WordPress content management system,
                      allowing him to easily update the website content and add new music tracks, videos, and photos. We
                      also provided him with ongoing support to ensure that the website was always up-to-date and
                      running smoothly. The result was a beautiful, custom-designed WordPress website that accurately
                      reflected Miguel's unique style and brand.
                    </p>{' '}
                    <h2>
                      <NextLink className="text-dark" title={All.HomeList[4].title} href="/" />
                    </h2>
                    <p>
                      The code is optimised for search engines, making it easy for companies to find his music online.
                      We undertook an SEO audit of the website and provided Miguel with a list of recommendations to
                      improve his website's search engine ranking. We also provided him with ongoing SEO services to
                      ensure that his website remained visible in search engine results.
                    </p>
                    <p>
                      Since launching the website, Miguel has received a lot of positive feedback from his site visitors
                      and has experienced an increase in website traffic and social media engagement.
                    </p>{' '}
                    <p>
                      At SEOptimist web design West Sussex, we're committed to delivering customized WordPress web design
                      solutions that meet our clients' unique needs. Contact us today to learn more about our web design
                      services and how we can help you achieve your online goals.
                    </p>{' '}
                  </div>

                  <div className="col-md-4 ms-auto">
                    <img
                      width={275}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-5"
                    />
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                  <NextLink title="Get in touch" href="/#contact" className="more hover" />
                  {/* ========== portfolio section ========== */}
                  <LocalSEO initialslide={0} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== navigation section ========== */}
        <ProjectDetailsNavigation />
        </main>

        <ContactFooterCombo location="brighton" />
    </Fragment>
  );
};

export default ProjectDetails;
